import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f51622be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "air-map-container" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "shade" }, [
  /*#__PURE__*/_createElementVNode("span", null, "按住 CTRL 并滚动鼠标滚轮才可以缩放地图")
], -1))

import { useStore, } from 'vuex';
import qs from 'qs';
import {
  computed, onMounted, watch, ref, onBeforeUnmount,
} from 'vue';
// import OLMap from '@/utils/OLMap';
import VueAMap from '@/utils/AMap';
// import MarkerOverLayer from '@/utils/OLMap/overLayer';
import PopupWindow from '@/utils/AMap/infoWindow';
// import PopUP from '@/components/popUP/index.vue';
import { getselecdedAqiImg, } from '@/utils/index';
import { AMapLightMap, } from '@/configs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// const olMapView = ref<any>({});
const AMapView = ref<any>({});
// 站点数据
const airQualityMapData = computed(() => store.state.gateway.airQualityMapData);

/**
 * 初始化地图
 * @returns {void}
 */
const initViewer = () => {
  const container = document.getElementById('air-map-container') as HTMLElement;

  if (container) {
    // olMapView.value = new OLMap(container, ['vec_w', 'cva_w',]);
    AMapView.value = new VueAMap('air-map-container', [104, 35,], 5, AMapLightMap);

    /*
     * store.commit('OLMap/setStateItem', {
     *   value: ['vec_w', 'cva_w',] ,
     *   type: 'mapType',
     * });
     */
    AMapView.value.setStatus({ scrollWheel: false, });
    AMapView.value.setStatus({ rotateEnable: false, });
    AMapView.value.on('mousewheel',() => {
      const shade = document.getElementById('shade');
      let time = null;

      if (shade) {
        shade.style.display = 'flex';
        if (time) clearTimeout(time);
        time = setTimeout(() => {
          shade.style.display = 'none';
        }, 1500);
      }
    });
  }
};
// 设置四至

// 获取当前区域四至
const regionIdExtent = computed(() => store.state.OLMap.regionIdExtent);
const selectCityExtent = computed(() => store.state.OLMap.selectCityExtent);
let extentFlag = false;

/*
 * const setExtent = (
 *   mapviewer: any,
 *   longitudeMin: any,
 *   latitudeMin: any,
 *   longitudeMax: any,
 *   latitudeMax: any
 * ) => {
 *   mapviewer.setExtent(
 *     [[longitudeMin, latitudeMin,], [longitudeMax, latitudeMax,],],
 *     [
 *       0,
 *       0,
 *       0,
 *       0,
 *     ]
 *   );
 * };
 */

watch([
  AMapView,
  regionIdExtent,
  selectCityExtent,
], ([
  curOL,
  curRe,
  curSe,
]) => {
  if (Object.keys(curOL).length && Object.keys(curSe).length) {
    const {
      longitudeMin, latitudeMin, longitudeMax, latitudeMax,
    } = curSe;

    // setExtent(curOL, longitudeMin, latitudeMin, longitudeMax, latitudeMax);
    curOL.setExtent(
      [[longitudeMin, latitudeMin,], [longitudeMax, latitudeMax,],],
      [0, 0,]
    );
  } else if (
    Object.keys(curOL).length &&
    Object.keys(curRe).length &&
    !extentFlag
  ) {
    const {
      longitudeMin,latitudeMin, longitudeMax, latitudeMax,
    } = curRe;

    extentFlag = true;
    // setExtent(curOL, longitudeMin, latitudeMin, longitudeMax, latitudeMax);
    curOL.setExtent(
      [[longitudeMin, latitudeMin,], [longitudeMax, latitudeMax,],],
      [0, 0,]
    );
  }
});

// 弹框功能
const popupEle = ref<any>(null);
const popup = ref<any>({});
const popupData = ref<any>({});
// 判断弹框是否关闭
const flagPop = ref<any>(false);
let flag = true;

watch([AMapView, popupEle,], ([current, value,], [old, oldValue,]) => {
  if (Object.keys(current).length && !Object.keys(old).length && value && flag) {
    flag = false;
    // popup.value = new MarkerOverLayer(current, value.popupEle, 'id');
    popup.value = new PopupWindow(value.popupEle);
  }
  if (Object.keys(current).length && !oldValue && value && flag) {
    flag = false;
    // popup.value = new MarkerOverLayer(current, value.popupEle, 'id');
    popup.value = new PopupWindow(value.popupEle);
  }
});

//  监听弹框是否关闭
watch(
  [
    flagPop,
    AMapView,
    airQualityMapData,
  ],
  ([
    curFlagPop,
    curOlMapView,
    curairQualityMapData,
  ]) => {
    if (
      !curFlagPop &&
       Object.keys(curOlMapView.enviromentStationLayer).length &&
       Object.keys(curairQualityMapData).length
    ) {
      // curOlMapView.enviromentStationLayer.closeInfoWIn();
      AMapView.value.clearInfoWindow();
    }
  }
);

// 上一个被点击的站点
const lastMarker = ref<any>(null);

/**
 * 环境站点绘制
 * @param {any} enData 传入站点数据列表
 * @returns {void} 绘制站点
 */
const drawEnvironments = (enData: any) => {
  if (Object.keys(enData).length) {
    AMapView.value.markEnvironments(enData,(e: any, params: any) => {
      store.commit('airStatus/setPointGid', qs.parse(params).pointGid);
      store.dispatch('gateway/getStationData', {
        params,
        callback: (data: any) => {
          // popup.value.setPupPostion(data);

          // 存储站点信息
          store.commit('airStatus/setPointInfo', data);

          // 直接传marker的位置marker.getPosition()

          // popup.value.open(AMapView.value, e.target.getPosition());
          popupData.value = data;
          flagPop.value = true;

          // 将上一个点击的站点变回默认样式
          if (lastMarker.value) {
            lastMarker.value.setOffset(new AMap.Pixel(0, 0));
            lastMarker.value.setStyle({
              width: '0.36rem',
              height: '0.36rem',
              'line-height': '0.33rem',
              background: `url(${getselecdedAqiImg(lastMarker.value.data.aqi === null ?
                -9999 :
                Number(lastMarker.value.data.aqi)).replace(/_selected/g, '')}) no-repeat`,
              'background-size': '100% 100%',
            });
          }
          // 将本次点击的图标变成高亮样式

          e.target.setOffset(new AMap.Pixel(6, 0));
          e.target.setStyle({
            width: '0.36rem',
            height: '0.432rem',
            'line-height': '0.312rem',
            background: `url(${getselecdedAqiImg(data.aqi === null ?
              -9999 :
              Number(data.aqi))}) no-repeat`,
            'background-size': '100% 100%',
          });

          lastMarker.value = e.target;
        },
      });
    });

    /*
     * olMapView.value.markEnvironments(
     *   'environment',
     *   enData,
     *   [0.5, 0.7,],
     *   (value: any, params: any) => {
     *     store.dispatch('gateway/getStationData', {
     *       params,
     *       callback: (data: any) => {
     *         popup.value.setPupPostion(data);
     *         popupData.value = data;
     *         flagPop.value = true;
     *       },
     *     });
     *   }
     * );
     */
  }
};

watch([AMapView, airQualityMapData,], ([curOL, curPro,]) => {
  if (Object.keys(curOL).length && Object.keys(curPro).length) {
    drawEnvironments(curPro);
  }
});

// AQI产品数据
const productDatas = computed(() => store.state.gateway.productDatas);

watch(
  [
    AMapView, productDatas,
  ],([
    curOlMapView, curproductDatas,
  ]) => {
    if (Object.keys(curOlMapView).length && Object.keys(curproductDatas).length) {
    // 卫星/站点产品要素
      const path = curproductDatas[Object.keys(curproductDatas)[Object.keys(curproductDatas).length - 1]]?.filePath;
      const extent = [[72, 17,], [136, 55,],];

      if (path) {
        curOlMapView.addPicture(
          path,
          extent
        );
      }
    }
  }
);

onMounted(() => {
  const dom = document.querySelector('.close-dom') as HTMLElement;

  initViewer();
  // drawEnvironments(airQualityMapData.value);

  if (dom) {
    dom.onclick = () => {
      popup.value.setPupPostion();
      flagPop.value = false;
    };
  }

  document.onkeydown = (e) => {
    const shade = document.getElementById('shade');

    // e.preventDefault();
    if (e.key === 'Control') {
      AMapView.value.setStatus({ scrollWheel: true, });
      AMapView.value.on('mousewheel',() => {
        if (shade) {
          shade.style.display = 'none';
        }
      });
    }
  };

  document.onkeyup = () => {
    AMapView.value.setStatus({ scrollWheel: false, });
    AMapView.value.on('mousewheel',() => {
      const shade = document.getElementById('shade');
      let time = null;

      if (shade) {
        shade.style.display = 'flex';
        if (time) clearTimeout(time);
        time = setTimeout(() => {
          shade.style.display = 'none';
        }, 600);
      }
    });
  };
});

onBeforeUnmount(() => {
  // olMapView.value.removeLayer(olMapView.value.enviromentStationLayer);

  // olMapView.value.dispose();
  store.commit('airStatus/setPointInfo', {});
  AMapView.value.destroy();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}
}

})